<template>
  <v-container
    class="fill-height"
    fluid>
    <v-row
      align="center"
      justify="center">
      <v-col
        cols="12"
        sm=""
        md="6">
        <v-card outlined>
          <v-window v-model="step">
            <v-window-item>
              <v-card-title class="justify-center">
                <h3>Zargon</h3>
              </v-card-title>
              <v-card-text>
                <div class="d-flex pa-8 justify-center">
                  <v-avatar
                    size=96
                    color="primary">
                    <v-icon size=64 dark>person</v-icon>
                  </v-avatar>
                </div>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation>
                  <v-text-field
                    v-model.trim="loginForm.email"
                    :rules="emailRules"
                    label="E-mailaddress"
                    name="loginEmail"
                    type="text"
                    autofocus
                    outlined
                    required />
                  <v-text-field
                    v-model.trim="loginForm.password"
                    :rules="passwordRules"
                    id="password"
                    label="Password"
                    name="password"
                    type="password"
                    outlined
                    required />
                </v-form>
                <transition name="fade">
                  <v-alert type="error" v-if="errorMsg != ''" class="error-msg">
                    {{ errorMsg }}
                  </v-alert>
                </transition>
                <v-progress-linear
                  :active="performingRequest"
                  :indeterminate="performingRequest"
                  absolute
                  bottom
                  color="primary" />
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" text @click="step = 1" depressed :disabled="performingRequest">Sign-up</v-btn>
                <v-spacer />
                <v-btn color="primary" @click="login" depressed>Login</v-btn>
              </v-card-actions>
            </v-window-item>
            <v-window-item>
              <v-toolbar flat>
                <v-btn icon @click="step = 0"><v-icon>arrow_back</v-icon></v-btn>
                <v-toolbar-title>Sign-up</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form
                  ref="signUpForm"
                  v-model="signUpValid"
                  lazy-validation>
                  <v-text-field
                    v-model.trim="signUpForm.displayName"
                    :rules="displayNameRules"
                    label="Display name"
                    name="display_name"
                    type="text"
                    autofocus
                    outlined
                    required />
                  <v-text-field
                    v-model.trim="signUpForm.email"
                    :rules="emailRules"
                    label="E-mailaddress"
                    name="email"
                    type="text"
                    outlined
                    required />
                  <v-text-field
                    v-model.trim="signUpForm.password"
                    :rules="passwordRules"
                    id="password"
                    label="Password"
                    name="password"
                    type="password"
                    outlined
                    required />
                  <v-text-field
                    v-model.trim="signUpForm.confirm"
                    :rules="passwordRules"
                    id="confirm"
                    label="Confirm"
                    name="confirm"
                    type="password"
                    outlined
                    required />
                </v-form>
                <!-- TODO: Remove this dirty hack and use flex-box or something -->
                <div style="height: 12px;"></div>
                <transition name="fade">
                  <v-alert type="error" v-if="signUpErrMsg != ''" class="error-msg">
                    {{ signUpErrMsg }}
                  </v-alert>
                </transition>
                <v-progress-linear
                  :active="performingRequest"
                  :indeterminate="performingRequest"
                  absolute
                  bottom
                  color="primary" />
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" text @click="step = 0" depressed>Cancel</v-btn>
                <v-spacer />
                <v-btn color="primary" @click="signUp" depressed :disabled="performingRequest">Sign-up</v-btn>
              </v-card-actions>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const fb = require('../../firebaseConfig.js')

export default {
  name: 'Login',
  data: function() {
    return {
      step: 0,
      valid: true,
      loginForm: {
        email: '',
        password: '',
      },
      signUpValid: true,
      signUpForm: {
        displayName: '',
        email: '',
        password: '',
        confirm: '',
      },
      performingRequest: false,
      errorMsg: '',
      signUpErrMsg: '',
      emailRules: [
        v => !!v || 'Email is required.',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid.',
      ],
      passwordRules: [
        v => !!v || 'Password is required.',
        v => v.length > 6 || 'Password must be at least 6 characters.'
      ],
      confirmRules: [
        v => v == this.signUpForm.password | 'Passwords do not match.'
      ],
      displayNameRules: [
        v => !!v || 'Display name is required.'
      ],
      authErrorMap: {
        'auth/user-not-found': 'There is no user with that e-mailaddress.',
        'auth/wrong-password': 'The password is invalid.'
      }
    }
  },
  methods: {
    login: function() {
      if(!this.$refs.form.validate()) {
        return
      }

      this.performingRequest = true

      fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
        this.$store.commit('setCurrentUser', user)
        this.$store.dispatch('fetchUserProfile')
        this.$router.push('/stories')

        this.performingRequest = false
      }).catch(err => {
        this.performingRequest = false
        if(this.authErrorMap[err.code]) {
          this.errorMsg = this.authErrorMap[err.code]
        } else {
          this.errorMsg = err.message
        }
      })
    },
    signUp: function() {
      if(!this.$refs.signUpForm.validate()) {
        return
      }

      this.performingRequest = true

      fb.auth.createUserWithEmailAndPassword(this.signUpForm.email, this.signUpForm.password)
        .then(userCredential => {
          console.log('created account')
          return userCredential.user.updateProfile({
            displayName: this.signUpForm.displayName,
          })
        })
        .then(() => {
          this.performingRequest = false

          console.log('pushign')
          this.$router.push('/stories')
        })
        .catch(err => {
          this.performingRequest = false
          console.log('err', err)
          this.signUpErrorMsg = err.message
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
